import generateDirective from 'angular/customer_application_bootstrap/angular/components/generator';
const controller = require('./controller');

generateDirective(
  'Personal',
  '/customer_application_renderer/stages/personal/form.html',
  controller
);
